const getters = {
  token: state => state.user.token,
  avater: state => state.user.avatar,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  identity_type: state => state.user.identity_type, // 是否开启管理后台 角色 1、员工 2、学员
  grade: state => state.user.grade, // 班级
  arrGrade: state => state.user.arrGrade, // 多班级数组
  grades_name: state => state.user.grade && state.user.grade.name || "", // 班级名称
  grades_type: state => state.user.card_info && state.user.card_info.type || "", // 班级类型 1、普通班级 2、培训班级
  is_face_recognition: state => state.user.grade && state.user.grade.is_face_recognition || "", // 是否开始人脸识别 1、是 2、否
  is_supervison: state => state.user.orgInfo && state.user.orgInfo.is_supervison || "", // 是否接入监管平台 1、是 2、否
  limit_study_time: state => state.user.grade && state.user.grade.limit_study_time || "", // 限制每天学习时长 单位小时 不得超过24小时
  question_id: state => state.user.grade && state.user.grade.question_id || "", // 试题id  判断是否需要考试  0 不需要考试 存在值需要考试
  grades_expired: state => state.user.grade && state.user.grade.grades_expired || "", // 培训班级是否过期  1、未过期 2、已过期
  card_info: state => state.user.card_info, // 是否开启名验证,直播等的存储对象
  is_verified: state => state.user.card_info.is_verified, // 是否开启实名认证 1、是 2、否
  stuVerified: state => state.user.stuVerified, // 学员是否已经实名认证 1、否 2、是
  is_live_broadcast: state => state.user.card_info.is_live_broadcast, // 是否启用直播  1、不启用 2、启用
  card_no: state => state.user && state.user.card_no, // 身份证号
  is_learn_again: state => state.permission.stateInfo.is_learn_again, // 课程学完是否可以再次学习 1、是 2、否
  is_video_drag: state => state.permission.stateInfo.is_video_drag, // 视频进度条是否可以拖动 1、是 2、否
  website: state => state.permission.stateInfo,
  loginId: state => state.user.loginId,
  errorLogs: state => state.errorLog.logs,
  interest: state => state.permission.is_lear_interest,
  perhome: state => state.permission.is_home,
  courseId: state => state.permission.a_id,
  orgData: state => state.permission.orgData,
  studentcms_name: state => state.permission.studentcms_name, // 学习作品展自定义名称
  infocms_name: state => state.permission.infocms_name, // 资讯通告自定义名称
  qapage: state => state.album.toqapage,
  mystutab: state => state.user.mystutab,
  infoNum: state => state.user.infoNum,
  oid: state => state.user.oid,
  closeComment: state => state.user.closeComment,
  orgInfo: state => state.user.orgInfo,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js